import { render, staticRenderFns } from "./SettingsOrderMenu.vue?vue&type=template&id=7d933f5e&scoped=true&"
import script from "./SettingsOrderMenu.vue?vue&type=script&lang=js&"
export * from "./SettingsOrderMenu.vue?vue&type=script&lang=js&"
import style0 from "./SettingsOrderMenu.vue?vue&type=style&index=0&id=7d933f5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d933f5e",
  null
  
)

export default component.exports